module.exports = __webpack_public_path__ + "img/reception-3.a4ec5b22.svg";